import { FC, ReactNode } from 'react';

import { SxProps, Theme } from '@mui/material';

import { ReactComponent as AlertIcon } from '@/assets/icons/alert-triangle-orange-icon.svg';
import { ReactComponent as InfoCircleIcon } from '@/assets/icons/info-circle-icon.svg';

import { Notice } from '../styles';

interface AwbNoticeProps {
  tone?: 'warning' | 'info';
  children: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

const AwbNotice: FC<AwbNoticeProps> = ({
  tone = 'warning',
  children,
  icon,
  sx,
  'data-testid': testId,
}) => (
  <Notice tone={tone} sx={sx} data-testid={testId}>
    {icon ??
      (tone === 'warning' ? (
        <AlertIcon style={{ flexShrink: 0 }} />
      ) : (
        <InfoCircleIcon style={{ flexShrink: 0 }} />
      ))}
    <span>{children}</span>
  </Notice>
);

export default AwbNotice;
